import { attachmentFileId, attachmentLinkId, defaultPurpose, isSensitiveAttachmentKind, type FileBucket, type PayloadOf } from '@gk/contracts'
import type { OverlayRow } from './db.ts'
import type { Projector } from './projectors.ts'

/** M15-V (docs/M15.md V): `attachment.register@2` is the register's FACT with its bucket, projected as @1's is — the link shows at once on the record it belongs
 *  to, with the SERVER's derived ids (the file v5(club, fingerprint), the link v5(file, "kind:record:purpose")), so the server's own row replaces it — and with
 *  the bucket asked and the purpose that bucket gives by default ('document' in the documents bucket, 'evidence' in the photos'), as the handler gives them.
 *  The server's row may name another bucket (bytes the club held already stay where they are): the pull's row is the truth. A link of a SENSITIVE record
 *  (ADR-119: an incident's evidence, a cost's invoice) projects nothing: its server row never comes back by the pull, so an overlay would stay for ever.
 *  The bytes wait in `blobs` either way (store.ts `addDocument`). Registered in projectors.ts under the M15b hook. */
export const attachmentRegister2: Projector = (cmd) => {
  const p = cmd.payload as PayloadOf<'attachment.register@2'>
  if (isSensitiveAttachmentKind(p.entity_type)) return []
  const fileId = attachmentFileId(cmd.org_id, p.sha256)
  const purpose = p.purpose ?? defaultPurpose(p.bucket as FileBucket)
  const id = attachmentLinkId(fileId, p.entity_type, p.entity_id, purpose)
  const row: OverlayRow = {
    key: `core.attachment_link:${id}`, table: 'core.attachment_link', id, command_id: cmd.command_id, op: 'insert',
    row: {
      id, org_id: cmd.org_id, site_id: cmd.site_id, file_id: fileId, sha256: p.sha256, bytes: p.bytes, mime: p.mime, entity_type: p.entity_type, entity_id: p.entity_id, purpose,
      caption: p.caption?.trim() || null, captured_at: p.captured_at, hidden_at: null, bucket: p.bucket, _pending: true,
    },
  }
  return [row]
}
